export default __webpack_public_path__ + "static/media/Diamond.792138a9.svg";